import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatFormField, MatHint, MatInputModule } from '@angular/material/input';
import { Address } from '../../../models/property.model';
import { State, US_STATES } from '../../../../../shared/general/models/us-states.model';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';

@Component({
  selector: 'app-address-edit',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatFormField,
    MatInputModule,
    MatDialogModule,
    MatDialogContent,
    MatDialogActions,
    MatHint,
    FormsModule,
    MatSelectModule,
    MatOptionModule
  ],
  templateUrl: './address-edit.html',
  styleUrl: './address-edit.scss',
})
export class AddressEdit implements OnInit {
  @Input() dialogRef?: MatDialogRef<any>;
  readonly data = inject<Address>(MAT_DIALOG_DATA);
  states: State[] = US_STATES;
  address!: Address;
  street = '';
  city = '';
  state = '';
  zipCode = '';

  ngOnInit(): void {
    this.address = { ...this.data };
  }
  
  @Output()
  private _save = new EventEmitter<Address>();

  public get save() {
    return this._save;
  }
  public set save(value) {
    this._save = value;
  }

  @Output()
  private _cancel = new EventEmitter<void>();
  public get cancel() {
    return this._cancel;
  }
  public set cancel(value) {
    this._cancel = value;
  }
}
